export const createWindow = () => (typeof window === 'undefined' ? null : window);
//# sourceMappingURL=window.js.map